import {
  Grid,
  Stack,
} from '@mantine/core'
import Account from '@data/accounts/model/account'
import { ReadOnlyField } from '@components/ui/form/ReadOnlyField'

export interface DeviceAccountTabProps {
  account?: Account | null
}

export const DeviceAccountTab = ({ account }: DeviceAccountTabProps) => {
  return (
    <Stack gap='lg'>
      <Grid>
        <Grid.Col span={12}>
          <ReadOnlyField label='Account Name' value={account?.accountName || ''} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={12}>
          <ReadOnlyField label='Address Line 1' value={account?.addressLine1 || ''} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={12}>
          <ReadOnlyField label='Address Line 2' value={account?.addressLine2 || ''} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField label='Town' value={account?.town || ''} />
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField label='Postcode' value={account?.postcode || ''} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField label='County' value={account?.county || ''} />
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField label='Country' value={account?.country || ''} />
        </Grid.Col>
      </Grid>
    </Stack>
  )
}
